import { ScheduleType } from 'mbs-ui-shared@models/backup/schedule-models';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { BackupFileFormModel } from 'wizards/models/backupFile/backup-form-model';
import { BaseBackupPlan } from 'wizards/models/base/base-backup-plan-model';
import { BaseForPlanHelper } from '../../models/base/base-models/base-for-plan-helper';

export class BackupFilePlanFromStepsHelper extends BaseForPlanHelper {
  public static BackupModel: BackupFileFormModel = null;

  public static getUpdatedPlan(
    plan,
    model: BackupFileFormModel,
    settings: WizardHelpersSettings,
    isNBF = false,
    isUnix = false
  ): BaseBackupPlan {
    this.BackupModel = model;
    this.isNBF = isNBF;
    this.isUnix = isUnix;
    this.isNetBuild = settings.isNetBuild;
    this.isNBFWithHybrid = isNBF && this.canHybridOnNbf(settings.agentVersion);
    this.updateSchedules(+ScheduleType[model.scheduleStep.ScheduleType] === ScheduleType.recurring, this.BackupModel.scheduleAdvancedStep);
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    this.BackupModel.compressionEncryptionStep.UseFileNameEncryption = !!this.BackupModel.compressionEncryptionStep.UseFileNameEncryption;
    PlanDataFromStepsHelper.updateNewPlanByNameStep(newPlan, this.BackupModel.planNameStep);

    if (this.isNBFWithHybrid) {
      PlanDataFromStepsHelper.updateNewPlanNBFHybridByWhereBackupStep(
        newPlan,
        this.BackupModel.whereBackupStep,
        this.isUnix && !this.isNetBuild
      );
    } else
      PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(
        newPlan,
        this.BackupModel.whereBackupStep,
        this.isNBF || (this.isUnix && !this.isNetBuild)
      );

    PlanDataFromStepsHelper.updateNewPlanByWhatBackupTreeStep(newPlan, this.BackupModel.whatBackupTreeStep);
    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStep(newPlan, this.BackupModel.compressionEncryptionStep, this.isNBF);

    if (!this.isNBF) {
      PlanDataFromStepsHelper.updateNewPlanByRetentionPolicyStep(
        newPlan,
        this.BackupModel.retentionPolicyStep,
        this.BackupModel.whereBackupStep.IsHybridBackup,
        this.isUnix && !this.isNetBuild
      );
      PlanDataFromStepsHelper.updateNewPlanByScheduleStep(
        newPlan,
        this.BackupModel.scheduleStep,
        this.BackupModel.scheduleAdvancedStep,
        this.BackupModel.simpleScheduleStep,
        this.isUnix && !this.isNetBuild
      );
    } else {
      PlanDataFromStepsHelper.updateNewPlanArchiveByArchiveConsistencyStep(newPlan, this.BackupModel.archiveConsistencyStep);
      PlanDataFromStepsHelper.updateNewNBFPlanByRetentionPolicyStep(
        newPlan,
        this.BackupModel.retentionPolicyStep,
        !this.isUnix || this.isNetBuild
      );

      if (this.isNBFWithHybrid) {
        PlanDataFromStepsHelper.updateNewNBFPlanWithHybridByRetentionPolicyStep(newPlan, this.BackupModel.retentionPolicyStep);
      }

      PlanDataFromStepsHelper.updateNewNBFPlanByScheduleStep(newPlan, this.BackupModel.scheduleStep, this.isUnix && !this.isNetBuild);
    }

    PlanDataFromStepsHelper.updateNewPlanByAdvancedOptionsStep(
      newPlan,
      this.BackupModel.advancedOptionsStep,
      this.BackupModel.advancedOptionsFlags,
      settings.planType,
      this.isNBF,
      this.isUnix,
      this.isNetBuild
    );
    PlanDataFromStepsHelper.updateNewPlanByAdvancedFilterStep(
      newPlan,
      this.BackupModel.advancedFilterStep,
      this.isUnix && !this.isNetBuild
    );
    if (this.BackupModel.scheduleStep.ScheduleType !== 'instantly') {
      PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(
        newPlan,
        this.BackupModel.prePostActionsStep,
        !settings.allowPrePostActions,
        this.isUnix && !this.isNetBuild
      );
    } else newPlan.Actions = { Pre: null, Post: null };
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.BackupModel.notificationStep, this.isUnix && !this.isNetBuild);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, !settings.isRD);
  }
}
